
import {Component, Vue} from "vue-property-decorator";
import preferencesService from "@/services/preferences.service";
import i18n from "@/plugins/vue-i18n";
import {namespace} from "vuex-class";
import frontService from "@/services/front.service";
import TooltipDialog from "@/components/utils/TooltipDialog.vue";
import FieldIdentifier from "@/components/utils/FieldIdentifier.vue";
import FieldIdentifierQualite from "@/components/utils/FieldIdentifierQualite.vue";
import panierService from "@/services/panier.service";

const userModule = namespace("userModule");

@Component({
    components: {TooltipDialog, FieldIdentifier, FieldIdentifierQualite},
})
export default class DocumentUser extends Vue {

    @userModule.State
    public user!: any;

    selectedType = 'comptage';

    headers = [
        {
            text: 'Date',
            value: 'date',
            filterable: false,
            align: 'center',
            width: '5vmax'
        },
        {
            text: 'Nom',
            value: 'name',
            filterable: false,
            width: '20vmax',
            align: 'left'
        },
        {
          text: 'Type',
          value: 'prefType',
          sortable: false,
          width:'4vmax'
        },
        {text: 'Actions', value: 'actions', align: 'center', sortable:false, width:'4px'},
        {text: '', value: '', sortable: false}
    ];
    files = [];

    name = "";
    stopLoading = false;
    isLoadingData = false;
    search = "";

    uploadingFile = null;
    dialogSelectId = false;
    dialogSelectIdQualite = false;
    headersSelectId = [];
    itemsSelectId = [];
    error = false;
    errorMessage = '';
    parsingLoading = false;
    selectedFileIdentifiers: string = null;
    selectedFileId: string = null;
    selectedId: string = null;
    selected = [];
    previewLoading = false;
    fileToUpload = null;
    info = false;
    interval;
    deleteModal = false;
    deleteSelectedModal = false;
    itemToDelete = "";

    created() {
        this.loadingFiles();
    }

    loadingFiles() {
        this.isLoadingData = true;
        preferencesService.getPreferencesFiles(this.user.id, ['enrichment', 'comptage', 'qualite']).then(res => {
            this.files = res.data.message.Items;
            this.isLoadingData = false;
        });
    }

    checkUpload(userId, uuid) {
        preferencesService.fileCheck(userId, uuid).then((res) => {
            if (res.data.message.filePreference.pending === false) {
                this.fileUploaded(res.data.message);
                clearInterval(this.interval);
                this.interval = null;
            }
        });
    }

    uploadFile() {
        this.error = false;
        this.stopLoading = false;
        this.dialogSelectId = false;
        if (this.fileToUpload) {
            const split = this.fileToUpload.name.split('.');
            const fileType = split[split.length - 1];
            if (this.fileToUpload.size <= 50000000 && (fileType === 'xlsx' || fileType === 'csv')) {
                this.parsingLoading = true;
                this.uploadingFile = true;
                if (this.fileToUpload.size > 20000000) {
                    this.info = true;
                }
                preferencesService
                    .uploadFileRepeller(this.fileToUpload, this.user.id, this.selectedType)
                    .then((res) => {
                        if (res.data.error) {
                            if (res.data.error.type === 0) {
                                this.info = false;
                                this.errorMessage = i18n.tc('error.wrong_format');
                                this.error = true;
                                this.uploadingFile = false;
                                this.parsingLoading = false;
                                this.$nextTick(() => this.fileToUpload = null);
                            }
                        } else if (this.uploadingFile) {
                            if (res.data.filePreference.pending === true) {
                                this.interval = setInterval(() => this.checkUpload(this.user.id, res.data.filePreference.uuid), 3000);
                                if (!this.info) {
                                    setTimeout(() => {
                                        if (this.interval) {
                                            this.info = true;
                                        }
                                    }, 5000);
                                }
                            } else {
                                this.fileUploaded(res.data.message);
                            }
                        }
                    }).catch((e) => {
                    console.log(e);
                    this.info = false;
                    this.errorMessage = i18n.tc('error.parsing');
                    this.error = true;
                    this.uploadingFile = false;
                    this.fileToUpload = null;
                    this.parsingLoading = false;
                });
            } else {
                this.uploadingFile = false;
                this.parsingLoading = false;
                if (this.fileToUpload.size > 50000000) {
                    this.errorMessage = i18n.tc('error.file_too_big');
                    this.error = true;
                } else if (fileType !== 'xlsx' && fileType !== 'csv') {
                    this.errorMessage = i18n.tc('error.wrong_format');
                    this.error = true;
                }
                this.$nextTick(() => this.fileToUpload = null);
            }
        }
    }

    clear() {
        this.error = false;
        this.info = false;
        clearInterval(this.interval);
        this.interval = null;
        this.parsingLoading = false;
    }

    countSelected() {
      let count = 0;
      for (let i = 0; i < this.selected.length; i++) {
        count++;
      }
      return count;
    }

    listSelected() {
      let list = "";

      for (let i = 0; i < this.selected.length; i++) {
        list = this.selected[i] + ", ";
      }
      return list;
    }

    deleteSelected() {
      this.deleteSelectedModal = true;
    }

    finalDeleteSelected() {
      this.isLoadingData = true;
      for (let i = 0; i < this.selected.length; i++) {
        preferencesService.deletePreferenceFiles(this.selected[i].uuid, this.user.id).then(() => {
          if (i === this.selected.length - 1) {
            this.loadingFiles();
            this.selected = [];
          }
        });
      }
    }

    deleteFileRepeller(item) {
      this.name = item.name;
      this.deleteModal = true;
      this.itemToDelete = item;
    }

    finalDeleteFileRepeller(uuid) {
      this.isLoadingData = true;
      preferencesService.deletePreferenceFiles(uuid, this.user.id).then(() => {
        this.loadingFiles();
      });
    }

    closeModale(identifiers) {
        if (identifiers && this.uploadingFile) {
            this.uploadingFile.identifiers = identifiers;
            // this.uploadFileDataUpdate([this.selectedId], [this.selectedFileId], this.uploadingFile);
            this.uploadingFile = null;
            //this.$emit('setIdentifier', identifiers);
            this.loadingFiles();
        } else if (identifiers && this.selected.length > 0) {
            // if (this.setFile[0].uuid === this.selectedFileId) {
            // this.$emit('setIdentifier', identifiers);
            // }
            this.loadingFiles();
        }
        this.dialogSelectId = false;
        this.dialogSelectIdQualite = false;
    }

    cancel(uuid) {
        if (this.uploadingFile) {
            this.deleteFileRepeller(uuid);
            this.uploadingFile = null;
        }
        this.fileToUpload = null;
        this.dialogSelectId = false;
        this.dialogSelectIdQualite = false;
    }

    fileUploaded(resMessage) {
        this.uploadingFile = resMessage.filePreference;
        if (this.uploadingFile.prefType === 'qualite') {
            this.dialogSelectIdQualite = true;
        } else {
            this.dialogSelectId = true;
        }
        this.itemsSelectId = resMessage.filePreview.Items;
        this.selectedFileId = resMessage.filePreference.uuid;
        this.selectedId = resMessage.filePreference.id;
        this.headersSelectId = this.createdHeadersFile(
            resMessage.filePreview.Items
        );
        // this.uploadFileDataUpdate([res.data.message.filePreference.id], [res.data.message.filePreference.uuid], event);
        this.parsingLoading = false;
        this.info = false;
    }

    createdHeadersFile(items) {
        const headers = [];

        if (items && items.length > 0) {
            const length = Object.keys(items[0]).length - 2;
            for (let index = 0; index < length; index++) {
                headers.push({
                    text: index + "",
                    value: index + ""
                });
            }
        }
        return headers;
    }

    preview(item) {
        this.previewLoading = true;
        this.itemsSelectId = [];

        preferencesService.previewFile(item.uuid).then(file => {
            this.selectedFileIdentifiers = item.identifiers;
            this.selectedFileId = item.uuid;
            this.itemsSelectId = file.data.message.Items;
            this.headersSelectId = this.createdHeadersFile(this.itemsSelectId);
            this.previewLoading = false;
            if (item.prefType === 'qualite') {
                this.dialogSelectIdQualite = true;
            } else {
                this.dialogSelectId = true;
            }
        });
    }

    customSort(items, index, isDesc) {
        return frontService.customSort('date', items, index, isDesc);
    }

    img(value) {
        return require('@/assets/' + value);
    }

    standardization(value) {
      let standarzidedValue = "";
        switch(value) {
          case 'comptage':
            standarzidedValue = "Comptage";
            break;
          case 'enrichment':
            standarzidedValue = "Enrichissement";
            break;
          case 'qualite':
            standarzidedValue = "Mise en qualité";
            break;
          default:
        }
      return standarzidedValue;
    }

    secondStandardization(value) {
      let standarzidedValue = "";
      switch(value) {
        case 'comptage':
          standarzidedValue = "du comptage (repoussoir)";
          break;
        case 'enrichment':
          standarzidedValue = "de l'enrichissement";
          break;
        case 'qualite':
          standarzidedValue = "de la mise en qualité";
          break;
        default:
      }
      return standarzidedValue;
    }

  downloadCSVFile(fileId) {
      preferencesService.getFile(fileId, this.user.id).then(res => {
        window.open(res.data.message.url, '_blank');
      }, err => {
        console.log(err);
      });
    }

    customFilter(value, search, item) {
        if(this.search) {
            const finalSearch = this.search.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            const finalValue = item.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            return finalValue.includes(finalSearch);
        } else {
            return false;
        }
    }
}
